module.exports = __webpack_public_path__ + "img/download-fill.de37331f.svg";